import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { resolveToken } from '../utils/tokenRouter';
import { useColorScheme } from '../hooks/useColorScheme';
import styles from './TokenRouter.module.css';

const MESSAGES = [
  'Verifying token…',
  'Resolving destination…',
  'Preparing redirect…',
];

export default function TokenRouter() {
  const { token: urlToken } = useParams();
  const scheme = useColorScheme();

  // On dark → white logo looks best on the dark bg during redirect
  // On light → color logo
  const logo = scheme === 'dark' ? '/logo-white.png' : '/logo-color.png';

  const [phase, setPhase] = useState('loading'); // 'loading' | 'error'
  const [msgIndex, setMsgIndex] = useState(0);
  const [errorInfo, setErrorInfo] = useState(null);

  useEffect(() => {
    if (!urlToken) {
      setPhase('error');
      setErrorInfo({ message: 'No token provided in URL.' });
      return;
    }

    const msgTimer = setInterval(() => {
      setMsgIndex((i) => (i + 1) % MESSAGES.length);
    }, 900);

    const resolveTimer = setTimeout(() => {
      const result = resolveToken(urlToken);

      if (result.error) {
        clearInterval(msgTimer);
        setPhase('error');
        setErrorInfo({ message: result.error });
        return;
      }

      clearInterval(msgTimer);
      window.location.href = result.url;
    }, 1800);

    return () => {
      clearInterval(msgTimer);
      clearTimeout(resolveTimer);
    };
  }, [urlToken]);

  if (phase === 'error') {
    return (
      <div className={styles.page}>
        <div className={styles.center}>
          <img src="/logo-color.png" alt="Logo" className={styles.logo} />
          <div className={styles.errorIcon}>✕</div>
          <p className={styles.errorTitle}>Redirect failed</p>
          <p className={styles.errorMsg}>
            {errorInfo?.message || 'This token could not be resolved.'}
          </p>
          <p className={styles.errorToken}>
            Token: <code>{urlToken || '—'}</code>
          </p>
          <a href="/" className={styles.homeLink}>← Go home</a>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <div className={styles.center}>
        <div className={styles.logoWrap}>
          <img src={logo} alt="Logo" className={styles.logo} />
          <div className={styles.logoGlow} />
        </div>

        <div className={styles.spinnerWrap}>
          <div className={styles.ring} />
          <div className={`${styles.ring} ${styles.ring2}`} />
        </div>

        <p className={styles.message}>{MESSAGES[msgIndex]}</p>
        <p className={styles.tokenLabel}>
          <span className={styles.tokenCode}>{urlToken}</span>
        </p>
      </div>
    </div>
  );
}
